import { useEffect, useState } from "react";
import { Disc3, Mic2 } from "lucide-react";

const Zone = ({ icon: Icon, title, hint, testId, onDrop }) => {
  const [over, setOver] = useState(false);
  return (
    <div
      data-testid={testId}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        onDrop([...e.dataTransfer.files]);
      }}
      className={`flex-1 flex flex-col items-center justify-center gap-3 border-2 border-dashed arch-top p-10 transition-colors ${
        over ? "border-[#D99B43] bg-[#D99B43]/10" : "border-[#5a1e28] bg-[#0f0d11]/80"
      }`}
    >
      <Icon size={36} className={over ? "text-amber-300" : "text-[#c92a3e]"} />
      <p className="font-gothic text-xl uppercase tracking-wider text-amber-100/90">{title}</p>
      <p className="font-cormorant italic text-stone-400 text-lg text-center">{hint}</p>
    </div>
  );
};

export const DropOverlay = ({ onSongs, onVocals }) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let depth = 0;
    const hasFiles = (e) => [...(e.dataTransfer?.types || [])].includes("Files");
    const enter = (e) => {
      if (!hasFiles(e)) return;
      depth++;
      setActive(true);
    };
    const leave = () => {
      depth = Math.max(0, depth - 1);
      if (!depth) setActive(false);
    };
    const reset = (e) => {
      e.preventDefault();
      depth = 0;
      setActive(false);
    };
    const over = (e) => hasFiles(e) && e.preventDefault();
    window.addEventListener("dragenter", enter);
    window.addEventListener("dragleave", leave);
    window.addEventListener("dragover", over);
    window.addEventListener("drop", reset);
    return () => {
      window.removeEventListener("dragenter", enter);
      window.removeEventListener("dragleave", leave);
      window.removeEventListener("dragover", over);
      window.removeEventListener("drop", reset);
    };
  }, []);

  if (!active) return null;
  return (
    <div data-testid="drop-overlay" className="fixed inset-0 z-[90] bg-[#080708]/85 backdrop-blur-md p-12 flex flex-col gap-6">
      <p className="eyebrow text-center text-[#D99B43]">⬥ Drop your audio — MP3, WAV, M4A, FLAC, OGG, AIFF · up to 50MB ⬥</p>
      <div className="flex-1 flex gap-6">
        <Zone testId="drop-zone-song" icon={Disc3} title="Import as song" hint="A backing track to sing over" onDrop={onSongs} />
        <Zone testId="drop-zone-vocal" icon={Mic2} title="Add as vocal" hint="A voice to mix and harmonize" onDrop={onVocals} />
      </div>
    </div>
  );
};
